import { defineComponent, h } from 'vue';
import { t } from '@/ui/i18n/i18n';
import { ValidationError } from '@/entities/validation';
import { VDataComponents } from '@/ui/helpers';
import { SelectOptionsWithId } from '@/ui/types';
import { FreeTagField } from '@/ui/components/form/FreeTagField';
import { Icon } from '@/ui/components/icon/Icon';

interface ChooseEntityFolderLabelFieldProps {
  options: SelectOptionsWithId<string>;
  value: string[];
  errors: ValidationError[];
  disabled?: boolean;
  required?: boolean;
  label?: string;
  tooltipText?: string;
  placeholder?: string;
  identifier?: string;
  hideLabel?: boolean;
}

export const ChooseEntityFolderLabelField = defineComponent<ChooseEntityFolderLabelFieldProps>({
  name: 'ChooseEntityFolderField',
  props: ['options', 'value', 'errors', 'label', 'placeholder', 'identifier', 'hideLabel', 'required', 'tooltipText'],
  setup(props, ctx) {
    return function render() {
      return h('div', { class: 'field entity-folder-labels__select' }, [
        h(FreeTagField, {
          props: {
            value: props.value,
            data: props.options,
            disabled: false,
            allowNew: true,
            autocomplete: true,
            selectableHeader: true,
            openOnFocus: true,
            placeholder: props.placeholder ?? t('user.user-to-entity-folder'),
            label: props.label ?? t('common.entity-folders'),
            name: 'entityFolders',
            required: props.required,
            errors: props.errors,
            hideLabel: props.hideLabel,
            addLabel: 'entity-folder.add-label',
            addLabelEmptyValue: 'entity-folder.placeholders.add-label',
            tooltipText: props.tooltipText,
          },
          ref: 'freeTagField',
          on: {
            input: (value: Array<string | number>) => ctx.emit('input', value),
          },
          scopedSlots: {
            empty: () => {
              return h('span', t('form.no-matches'));
            },
            default: ({ option }) => {
              return h('div', { class: 'entity-folder-label__tag-row' }, [
                h('span', option.label),
                h('a', {
                  on: {
                    click(ev: Event) {
                      ev.preventDefault();
                      ev.stopPropagation();

                      ctx.emit('removeLabel', { value: <string>option.value });
                    },
                  },
                }, [
                  h(Icon, {
                    props: {
                      icon: 'trash-alt',
                    },
                  }),
                ]),
              ]);
            },
          },
        }),
      ]);
    };
  },
});

export const chooseEntityFolderLabelField = (data: VDataComponents<ChooseEntityFolderLabelFieldProps>) => h(ChooseEntityFolderLabelField, data);
